module.exports = __webpack_public_path__ + "static/Lora-Regular-c684a3de5c014a61d5139d5b97da99fc.ttf";